// extracted by mini-css-extract-plugin
export default {"tooltip":"DU-z","arrow":"EU-z"};